import React, { useState } from "react";
import NotePanel, { Props } from "../NotePanel/NotePanelBase/NotePanel";

interface ViewProps extends Omit<Props, "mode"> {
  note: any;
}

export default function ViewNotePanel({ note, ...props }: ViewProps) {
  const [mode, setMode] = useState<"view" | "edit">("view");

  const handleChangeMode = (newMode: "create" | "edit" | "view") => {
    if (newMode === "create") return;
    setMode(newMode);
  };
  return (
    <NotePanel
      mode={mode}
      noteId={note.id}
      initialSubject={note.title}
      initialMessage={note.note}
      initialCategoryName={note.categoryName}
      onChangeMode={handleChangeMode}
      {...props}
    />
  );
}
